module.exports = __webpack_public_path__ + "img/TDC-L2-7-Pagina2 B.787096c5.png";